import React, {Component} from 'react';
import { Slider } from '@carbon/react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

class CCSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.min = 0;
		this.max = 127;
		this.ccBipolar = (props.ccBipolar && props.ccBipolar != 0) ? true : false;
		this.restoreChangeTimer = null;

		this.handleChange = this.handleChange.bind(this);
		this.formatLabel  = this.formatLabel.bind(this);
	}

	render() {
		var onChange = this.state.suppressChange ? undefined : this.handleChange;

		/*
		 * min: minimum value
		 * max: maximum value
		 * step: 
		 * stepMultiplier: (note: it is misspelled as 'stepMuliplier' in the
		 * Carbon Slider component)
		 * formatLabel: used to format 
		 */
		return (
			<Slider value={this.state.value} min={this.min} max={this.max} step={1} stepMuliplier={8} stepMulitplier={8} labelText={this.labelText} formatLabel={this.formatLabel} onChange={onChange} disabled={this.state.disabled} hideTextInput="1"/>
		);
	}

	handleChange(props) {
		var newValue = Number(props.value)
		this.setState({value: newValue});
		midi.sendControlChange(this.ccNum, newValue);
	}

	formatLabel(value, label) {
		return '';
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue);
	}

	setValue(x) {
		if (this.restoreChangeTimer) {
			clearTimeout(this.restoreChangeTimer);
		}
		this.setState({value: x, suppressChange: true});
		this.restoreChangeTimer = setTimeout(() => {
			this.restoreChangeTimer = null;
			this.setState({suppressChange: false});
		}, 50);
	}
}

export default CCSlider;
